<template>
<div ref="baseFileList" id="base-file-list">
    <transition name="fade" mode="out-in">
    <div id="loading-block" v-if="isLoadingBaseFiles">
        <loading-block
            :message="trans.loading_file_list"
        />
    </div>
    <div v-else>
        <transition name="fade" mode="out-in">
        <div
            v-if="listIsEmpty"
            class="has-text-centered p-5"
        >
            <i class="far fa-folder-open fa-xl fa-5x has-text-grey-light mb-1"/>
        <p>
            {{ trans.file_list_is_empty }}
        </p>
        <p>
            {{ trans.to_upload_files }}
        </p>
        </div>
        <div v-else>
        <table
            class="table is-fullwidth"
        >
            <thead>
            <tr>
                <th></th>
                <th>{{  trans.filename }}</th>
                <th>{{ trans.author }}</th>
                <th>{{  trans.filesize }}</th>
                <th>
                    <abbr :title="trans.public_description">
                        {{ trans.public }}
                    </abbr>
                </th>
            </tr>
            </thead>
            <tbody
                is="transition-group"
                mode="out-in"
                name="fade"
            >
                <base-file-row
                    class="kek"
                    :file="file"
                    :key="index"
                    v-for="(file, index) of this.list"
                />
            </tbody>
        </table>
        </div>
        </transition>
    </div>
    </transition>
</div>
</template>

<script>
import {mapState} from "vuex";
import BaseFileRow from "./FileRow";
import LoadingBlock from "../../utils/LoadingBlock";

export default {
    name: "BaseFileList",
    components: {LoadingBlock, BaseFileRow},
    computed: {
        ...mapState('fileManagement', {
            list: 'baseFiles'
        }),
        ...mapState('fileManagement', [
            'actions',
            'trans',
            'isLoadingBaseFiles',
            'usedBaseDiskSpace',
            'isUploadingFile'
        ]),
        listIsEmpty() {
            return Object.values(this.list).length <= 0
        }
    },
    watch: {
        isUploadingFile(value) {
            if (value) {
                return;
            }

            this.$nextTick(() => {
                this.$refs.baseFileList.scrollIntoView(false);
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    $minHeight: 300px;

    th {
        position: sticky;
        top: 0;
        background: white;
        z-index: 1;
    }

    #base-file-list {
        min-height: $minHeight;
    }

    #loading-block {
        display: flex;
        align-items: center;
        justify-content: center;
        height: $minHeight;
    }
</style>
